import '../PublicPage.css';

export default function GermanyItineraryPage() {
    return (
        <div className="public-page germany-page">
            <header className="public-hero">
                <div className="public-hero-content">
                    <h1>Germany Itinerary</h1>
                    <p>Fairytale castles, historic cities, and engineering excellence.</p>
                </div>
            </header>

            <section className="public-section white-bg">
                <div className="section-inner">
                    <div className="story-grid">
                        <div className="modern-card">
                            <h3>Why visit Germany?</h3>
                            <p>Germany combines rich history with modern innovation. Explore the vibrant streets of Berlin, the romantic roads of Bavaria, and the dense forests of the Black Forest.</p>
                        </div>
                        <div className="modern-card">
                            <h3>Featured: Romantic Road Adventure</h3>
                            <p>From Frankfurt to Munich, visiting Rothenburg and Neuschwanstein Castle. A true fairytale experience.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="public-section slate-bg">
                <div className="section-inner">
                    <h2>Top Destinations</h2>
                    <ul className="benefits-list">
                        <li><strong>Berlin</strong>: A capital of culture and history.</li>
                        <li><strong>Munich</strong>: Beer gardens and Bavarian tradition.</li>
                        <li><strong>The Rhine</strong>: Scenic cruises and medieval castles.</li>
                        <li><strong>Black Forest</strong>: Nature, cuckoo clocks, and hiking.</li>
                    </ul>
                </div>
            </section>

            <section className="public-section white-bg" style={{ textAlign: 'center' }}>
                <div className="section-inner">
                    <h2>Ready to plan your Germany trip?</h2>
                    <p style={{ marginBottom: '32px' }}>Let Raisa AI create a personalized itinerary for you in seconds.</p>
                    <button className="submit-btn-primary" style={{ maxWidth: '300px' }} onClick={() => window.location.href = '/?prompt=Plan an 8-day trip to Germany covering Berlin, Munich and the Romantic Road'}>
                        Plan my Germany Trip
                    </button>
                </div>
            </section>
        </div>
    );
}
